import axios from "axios";
import i18n from "../../i18n.js";

// Maps a currency code to a locale registered in i18n.js numberFormats.
// Defaults to es-CO so $n always receives a valid (registered) locale.
const currencyToLocale = (currency) => {
  switch (currency) {
    case 'MXN': return 'es-MX';
    case 'PEN': return 'es-PE';
    case 'CLP': return 'es-CL';
    case 'USD': return 'en-US';
    case 'BRL': return 'pt-BR';
    case 'CRC': return 'es-CR';
    default:    return 'es-CO';
  }
};

const state = {
  instance: {
    suppliers: [],
    theme: {},
    preload: {}
  },
  supplier: { id: 0 },
  polygon: { supplier_id: null }, 
  disableTip:false,
  valueOrderMin:false,
  isCinema:false,
  isPreview: false
};

const getters = {
  instance_id: state => {
    return state.instance.id;
  },
  supplier_id: state => {
    return state.supplier.id;
  },
  getDisableTip: state => {
    return state.disableTip;
  },
  getValueOrderMin: state => {
    return state.valueOrderMin;
  },
  getIsCinema: state => {
    return state.isCinema;
  },
  pixel_google_analytics: state => {
    return state.instance.pixel_google_analytics;
  },
  pixel_facebook_analytics: state => {
    return state.instance.pixel_facebook_analytics;
  },
  has_cluvipay: state => {
    return state.supplier.has_cluvi_pay
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_checkout: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class === 'checkout' && rootGetters['order/is_ontable_service'] && rootState.ontable.tableId !== '';
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_basic: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class == 'basic' &&
        rootGetters['order/is_ontable_service'] ||
        (
          !getters.is_ontable_plazoleta &&
          !getters.is_ontable_noincremental &&
          !getters.is_ontable_checkout
        )
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_plazoleta: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class == 'checkout_plazoleta' && rootGetters['order/is_ontable_service'];
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_noincremental: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class == 'checkout_no_incremental' && rootGetters['order/is_ontable_service'] && rootState.ontable.tableId !== '';

  },
  // eslint-disable-next-line no-unused-vars
  mandatory_payment: (state, getters, rootState, rootGetters) => {
    return getters.is_ontable_noincremental || getters.is_ontable_plazoleta || rootGetters.is_room_service
  },
  // eslint-disable-next-line no-unused-vars
  mandatory_send_to_prepare: (state, getters) => {
    return getters.is_ontable_checkout;
  },
  is_colombian_customer: (state) => {
    return state.instance.country_code === 'CO';
  },
  is_mexican_customer:(state) => {
    return state.instance.country_code === 'MX';
  },
  price_currency_locale:(state) => (price) => {
    return i18n.n(price, 'currency', currencyToLocale(state.instance.currency));
  },
  getLabels:  (state) => (tag) => {
    const labels = i18n.t(tag);
    const key = Object.keys(labels).find(x => x === state.instance.country_code);
    if (key) {
      return labels[key];
    } else {
      return labels['DEFAULT'];
    }
  },
  is_peruvian_customer:(state) => {
    return state.instance.country_code === 'PE';
  }
};

const actions = {
  async InitInstance({commit, dispatch}) {
    const url = `${process.env.VUE_APP_API_EXP}/domain/config.json`;
    const res = await axios.get(url);
    commit("customer/SetConfig", res.data, {root: true});
    dispatch("profile/InitSession", null, {root: true});
  },
  async GetSupplier({commit}, slug) {
    const supplierCandidates = [
      `${process.env.VUE_APP_API_EXP}/domain/suppliers/${slug}.json`,
      `${process.env.VUE_APP_API_EXP}/api/suppliers/${slug}.json`
    ];

    let lastError = null;

    for (const url of supplierCandidates) {
      try {
        const res = await axios.get(url);
        if (res?.data && Object.keys(res.data).length > 0) {
          commit("customer/SetSupplier", res.data, {root: true});
          return;
        }
      } catch (error) {
        lastError = error;
      }
    }

    throw lastError || new Error(`Supplier not found for slug: ${slug}`);
  },
  async GetSupplierByBranch({commit}, id) {
    const url = `${process.env.VUE_APP_API_EXP}/domain/branches/${id}.json`;
    const res = await axios.get(url);
    commit("customer/SetSupplier", res.data, {root: true});
  }
};

const mutations = {
  SetConfig(state, data) {
    state.instance = { ...data, currency_locale: currencyToLocale(data.currency) };
  },
  SetDisableTip(state, data) {
    state.disableTip = data;
  },
  SetValueOrderMin(state, data) {
    state.valueOrderMin = data;
  },
  SetIsCinema(state, data) {
    state.isCinema = data;
  },
  SetSupplier(state, supplier) {
    state.supplier = supplier;
  },
  SetPolygon(state, data) {
    state.polygon = data;
  },
  SetIsPreview(state, data) {
    state.isPreview = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
